import { useFetchRequest } from "@app/hooks/useFetchRequest";

type FetchRequestProps = {
  endpoint: string;
  payload?: object;
};

/**
 * Guarded fetch request: only triggers when `shouldFetch` is true.
 */
export function useGuardedFetchRequest<T>(
  shouldFetch: boolean,
  props: FetchRequestProps,
) {
  const skipProps = {
    endpoint: "",
    payload: {},
    skip: true,
  };

  return useFetchRequest<T>(shouldFetch ? props : skipProps);
}
